import moment from 'moment';

moment.locale('pt-br');

export default class DateParser {
  static parseFromTimestamp(value) {
    return moment.unix(value).format('DD/MM/YYYY');
  }

  static humanize(date) {
    return moment().to(moment(date, 'DD/MM/YYYY'));
  }

  static _compare(date, fn) {
    return moment(date, 'DD/MM/YYYY')[fn](moment(), 'day');
  }

  static isBeforeToday(date) {
    return DateParser._compare(date, 'isBefore');
  }

  static isTodayOrBefore(date) {
    return DateParser._compare(date, 'isSameOrBefore');
  }

  static isAfterToday(date) {
    return DateParser._compare(date, 'isAfter');
  }
}
